import {styledByTheme} from "../../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoArenaNavbarButtonwrapperDefaultBox} from "./live-casino-arena-navbar-button-wrapper.default.box";

export const LiveCasinoArenaNavbarButtonWrapperBox = styledByTheme(LiveCasinoArenaNavbarButtonwrapperDefaultBox)
    .apply();
